module.exports = __webpack_public_path__ + "static/img/testimony (18).5caa1ec2.jpg";